/* eslint-disable react-hooks/exhaustive-deps */
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useTheme, ToggleButton, styled, Box } from "@mui/material";
import { MeasurementType } from "../../../viewer/measurement/types";

import {
  DETAIL_TAB2POINT_CLOUD_TYPE,
  ProjectDetailContext,
} from "../Interfaces/ProjectDetailInterfaces";
import { POINT_CLOUD_TYPE } from "../../../../common/src/modules";
import CalcContext from "../Contexts/CalcContext";
import {
  MeasurementVolumeIcon,
  MeasurementTwoPointIcon,
  MeasurementHorizontalIcon,
  MeasurementFlatAreaIcon,
  MeasurementSurfaceIcon,
  MeasurementVerticalIcon,
  MeasurementMultipleIcon,
} from "../../Parts/Q3DIcons";
import Q3DIconButton from "../../Parts/Q3DIconButton";

const DARK = "dark";

interface ToolBoxProps {}

export const MeasurementTypeButtons = (props: ToolBoxProps) => {
  const { t, i18n } = useTranslation();
  const { currentPointCloud, detailTab } = useContext(ProjectDetailContext);
  const { measurementType, setMeasurementType, onEditingMode } =
    useContext(CalcContext);

  const theme = useTheme();

  return (
    <Box>
      {DETAIL_TAB2POINT_CLOUD_TYPE(detailTab) !== POINT_CLOUD_TYPE.SIMPLE && (
        <Q3DIconButton
          title={t("VOLUME")}
          titleType={i18n.language === "ja" ? "both" : "tooltip"}
          disabled={onEditingMode}
          disabledHoverAnimation={
            measurementType === MeasurementType.VOLUME_CALCULATION
          }
          icon={
            <MeasurementVolumeIcon
              width={20}
              height={20}
              color={
                measurementType === MeasurementType.VOLUME_CALCULATION &&
                !onEditingMode &&
                "white"
              }
            />
          }
          height={"36px"}
          onClick={() => {
            setMeasurementType(
              measurementType === MeasurementType.VOLUME_CALCULATION
                ? null
                : MeasurementType.VOLUME_CALCULATION
            );
          }}
          sx={{
            background:
              measurementType === MeasurementType.VOLUME_CALCULATION
                ? theme.palette.base.ymdBackground
                : "#00000000",
            color:
              measurementType === MeasurementType.VOLUME_CALCULATION
                ? "#FFFFFF"
                : theme.palette.base.contrast,
            border: `1px solid ${theme.palette.base.border} !important`,
            padding: "0px",
            whiteSpace: "nowrap",
            borderRadius: "0px",
            minWidth: "36px",
          }}
        />
      )}
      <Q3DIconButton
        title={t("TWO_POINTS")}
        titleType={i18n.language === "ja" ? "both" : "tooltip"}
        disabled={onEditingMode}
        disabledHoverAnimation={measurementType === MeasurementType.TWO_POINT}
        icon={
          <MeasurementTwoPointIcon
            width={20}
            height={20}
            color={
              measurementType === MeasurementType.TWO_POINT &&
              !onEditingMode &&
              "white"
            }
          />
        }
        height={"36px"}
        onClick={() => {
          setMeasurementType(
            measurementType === MeasurementType.TWO_POINT
              ? null
              : MeasurementType.TWO_POINT
          );
        }}
        sx={{
          background:
            measurementType === MeasurementType.TWO_POINT
              ? theme.palette.base.ymdBackground
              : "#00000000",
          color:
            measurementType === MeasurementType.TWO_POINT
              ? "#FFFFFF"
              : theme.palette.base.contrast,
          border: `1px solid ${theme.palette.base.border} !important`,
          padding: "0px",
          whiteSpace: "nowrap",
          borderRadius: "0px",
          minWidth: "36px",
        }}
      />
      <Q3DIconButton
        title={t("MULTIPLE_POINTS")}
        titleType={i18n.language === "ja" ? "both" : "tooltip"}
        disabled={onEditingMode}
        disabledHoverAnimation={
          measurementType === MeasurementType.MULTIPLE_POINT
        }
        icon={
          <MeasurementMultipleIcon
            width={20}
            height={20}
            color={
              measurementType === MeasurementType.MULTIPLE_POINT &&
              !onEditingMode &&
              "white"
            }
          />
        }
        height={"36px"}
        onClick={() => {
          setMeasurementType(
            measurementType === MeasurementType.MULTIPLE_POINT
              ? null
              : MeasurementType.MULTIPLE_POINT
          );
        }}
        sx={{
          background:
            measurementType === MeasurementType.MULTIPLE_POINT
              ? theme.palette.base.ymdBackground
              : "#00000000",
          color:
            measurementType === MeasurementType.MULTIPLE_POINT
              ? "#FFFFFF"
              : theme.palette.base.contrast,
          border: `1px solid ${theme.palette.base.border} !important`,
          padding: "0px",
          whiteSpace: "nowrap",
          borderRadius: "0px",
          minWidth: "36px",
        }}
      />
      <Q3DIconButton
        title={t("HORIZONTAL")}
        titleType={i18n.language === "ja" ? "both" : "tooltip"}
        disabled={onEditingMode}
        disabledHoverAnimation={measurementType === MeasurementType.HORIZONTAL}
        icon={
          <MeasurementHorizontalIcon
            width={20}
            height={20}
            color={
              measurementType === MeasurementType.HORIZONTAL &&
              !onEditingMode &&
              "white"
            }
          />
        }
        height={"36px"}
        onClick={() => {
          setMeasurementType(
            measurementType === MeasurementType.HORIZONTAL
              ? null
              : MeasurementType.HORIZONTAL
          );
        }}
        sx={{
          background:
            measurementType === MeasurementType.HORIZONTAL
              ? theme.palette.base.ymdBackground
              : "#00000000",
          color:
            measurementType === MeasurementType.HORIZONTAL
              ? "#FFFFFF"
              : theme.palette.base.contrast,
          border: `1px solid ${theme.palette.base.border} !important`,
          padding: "0px",
          whiteSpace: "nowrap",
          borderRadius: "0px",
          minWidth: "36px",
        }}
      />
      <Q3DIconButton
        title={t("VERTICAL")}
        titleType={i18n.language === "ja" ? "both" : "tooltip"}
        disabled={onEditingMode}
        disabledHoverAnimation={measurementType === MeasurementType.VERTICAL}
        icon={
          <MeasurementVerticalIcon
            width={20}
            height={20}
            color={
              measurementType === MeasurementType.VERTICAL &&
              !onEditingMode &&
              "white"
            }
          />
        }
        height={"36px"}
        onClick={() => {
          setMeasurementType(
            measurementType === MeasurementType.VERTICAL
              ? null
              : MeasurementType.VERTICAL
          );
        }}
        sx={{
          background:
            measurementType === MeasurementType.VERTICAL
              ? theme.palette.base.ymdBackground
              : "#00000000",
          color:
            measurementType === MeasurementType.VERTICAL
              ? "#FFFFFF"
              : theme.palette.base.contrast,
          border: `1px solid ${theme.palette.base.border} !important`,
          padding: "0px",
          whiteSpace: "nowrap",
          borderRadius: "0px",
          minWidth: "36px",
        }}
      />
      <Q3DIconButton
        title={t("FLAT_AREA")}
        titleType={i18n.language === "ja" ? "both" : "tooltip"}
        disabled={onEditingMode}
        disabledHoverAnimation={
          measurementType === MeasurementType.FLAT_AREA_CALCULATION
        }
        icon={
          <MeasurementFlatAreaIcon
            width={20}
            height={20}
            color={
              measurementType === MeasurementType.FLAT_AREA_CALCULATION &&
              !onEditingMode &&
              "white"
            }
          />
        }
        height={"36px"}
        onClick={() => {
          setMeasurementType(
            measurementType === MeasurementType.FLAT_AREA_CALCULATION
              ? null
              : MeasurementType.FLAT_AREA_CALCULATION
          );
        }}
        sx={{
          background:
            measurementType === MeasurementType.FLAT_AREA_CALCULATION
              ? theme.palette.base.ymdBackground
              : "#00000000",
          color:
            measurementType === MeasurementType.FLAT_AREA_CALCULATION
              ? "#FFFFFF"
              : theme.palette.base.contrast,
          border: `1px solid ${theme.palette.base.border} !important`,
          padding: "0px",
          whiteSpace: "nowrap",
          borderRadius: "0px",
          minWidth: "36px",
        }}
      />
      <Q3DIconButton
        title={"Surface"}
        titleType={i18n.language === "ja" ? "both" : "tooltip"}
        disabled={onEditingMode}
        disabledHoverAnimation={measurementType === MeasurementType.SURFACE}
        icon={
          <MeasurementSurfaceIcon
            width={20}
            height={20}
            color={
              measurementType === MeasurementType.SURFACE &&
              !onEditingMode &&
              "white"
            }
          />
        }
        height={"36px"}
        onClick={() => {
          setMeasurementType(
            measurementType === MeasurementType.SURFACE
              ? null
              : MeasurementType.SURFACE
          );
        }}
        sx={{
          background:
            measurementType === MeasurementType.SURFACE
              ? theme.palette.base.ymdBackground
              : "#00000000",
          color:
            measurementType === MeasurementType.SURFACE
              ? "#FFFFFF"
              : theme.palette.base.contrast,
          border: `1px solid ${theme.palette.base.border} !important`,
          padding: "0px",
          whiteSpace: "nowrap",
          borderRadius: "0px",
          minWidth: "36px",
        }}
      />
    </Box>
  );
};
